import $ from "jquery";

import Backdraft from "backdraft-app/src/backdraft";

import Recording from "shared/browser_audio_player/models/recording";

Backdraft.app("Header", function(app) {
  app.Models.Recording = Recording;

  app.model("TtsRecording", "Recording", {
    handleClick: function() {
      if (this._isStopped()) {
        this.trigger('beforePlay');
        if (!this.isValid()) {
          this._setErrorMessage(this.validationError);
          return;
        }
      }
      app.Models.TtsRecording.__super__.handleClick.apply(this, arguments);
    },

    validate: function(attrs, options) {
      var promptText = attrs.recordId, error;
      if (!promptText) {
        error = 'Prompt text cannot be blank';
      } else if (!this._canBePronounced(promptText)) {
        error = 'Prompt text must contain at least one letter or number';
      }
      return error;
    },

    togglePlay: function() {
      if (this._isStopped() && !this.isValid()) {
        return;
      }
      app.Models.TtsRecording.__super__.togglePlay.apply(this, arguments);
    },

    fetch: function(options) {
      var request = $.Deferred();
      request.done(function(response) {
        this.set('downloadUrl', response.recordingUrl);
        if (options.success) {
          options.success(this, response);
        }
      }.bind(this))
        .fail(function(response) {
          if (options.error) {
            options.error(this, response);
          }
        }.bind(this));

      this._retrieveRecordingUrl(this.get('recordId'), request, 30);
    },

    _retrieveRecordingUrl: function(promptText, request, retries) {
      var self = this, url;
      $.ajax({
        url: this.get('url'),
        data: {
          text: promptText
        },
        method: "GET"
      }).done(function(data) {
        url = data.url;
        if (url !== null && url.trim() !== '') {
          request.resolve({ recordingUrl: url });
        } else if (retries > 0) {
          setTimeout(function() {
            self._retrieveRecordingUrl(promptText, request, retries - 1);
          }, 1000);
        } else {
          request.reject({ status: 404, responseText: "Sorry, recording is unavailable." });
        }
      }).fail(function(response) {
        request.reject(response);
      });
    },

    _setErrorMessage: function(message) {
      this.set('alertMessage', message);
      this.trigger('change change:alertMessage');
    },

    _canBePronounced: function(text) {
      return text.match(/[a-z0-9]/i);
    },

    _isStopped: function() {
      return !this.get('play') && !this.loading();
    }
  });
});
